// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"402":"9ea76a82","429":"618825cc","440":"e0dbac29","551":"b0ffe9f2","640":"6534b57c","842":"01821987"}[chunkId] + ".chunk.js";
};